import { css } from '@emotion/css';

export const yjsCursorsStyles = css`
  /* this is a rough fix for the first cursor position when the first paragraph is empty */

  .ProseMirror > .ProseMirror-yjs-cursor:first-child {
    margin-top: 16px;
  }

  .tooltip {
    position: relative;
  }

  .tooltip .tooltiptext {
    visibility: hidden;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 100%;
    left: 0;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  /* This gives the remote user caret. The colors are automatically overwritten*/

  .ProseMirror-yjs-cursor {
    position: relative;
    margin-inline-start: -1px;
    margin-inline-end: -1px;
    border-left: 1px solid black;
    border-right: 1px solid black;
    word-break: normal;
    padding: 2px 0;
    border-radius: 0 0 10px 10px;
  }

  /* This renders the username above the caret */
  .ProseMirror-yjs-cursor .cursor-handle {
    position: absolute;
    width: 8px;
    height: 8px;
    top: -6px;
    left: -4px;
    pointer-events: none;
    border-radius: 50%;
    transition: 0ms opacity 3s;
    opacity: 1;
  }

  .ProseMirror-yjs-cursor:hover .cursor-handle {
    transition: 0ms opacity 0s;
    opacity: 0;
  }

  .ProseMirror-yjs-cursor .cursor-name {
    position: absolute;
    top: -2rem;
    left: -1px;
    font-style: normal;
    padding: 2px 4px;
    border-radius: 2px 2px 2px 0;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
    white-space: nowrap;
    font-weight: var(--fw-body-short-03);
    font-family: var(--ff-body-short-03);
    font-size: var(--fs-body-short-03);
    line-height: var(--lh-body-short-03);
    letter-spacing: var(--ls-body-short-03);
    transition: 0ms opacity 3s;
    opacity: 0;
  }

  .ProseMirror-yjs-cursor:hover .cursor-name {
    transition: 0ms opacity 0s;
    opacity: 1;
  }
`;
